module.exports = __webpack_public_path__ + "landing_static/img/stars-left.d6b8f5fe.png";